// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__cO2aK","topBottomGutter":"Layout_topBottomGutter__3bnoA"};